// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

// -------------------------------
//  Request State
// -------------------------------
export interface RequestState extends EntityState<any> {
  common?: any;
  userRequestList: Array<any>;
 }

// -------------------------------
//  Request Adapter
// -------------------------------
export const requestAdapter: EntityAdapter<any> = createEntityAdapter<any>({
});

// -------------------------------
//  Request Initial State
// -------------------------------
export const initialState: RequestState = requestAdapter.getInitialState(
  {
  common: null,
  userRequestList: [],
  },
);
